import start from './src/start';
import info_popup, {info_popup_listeners} from '../../brackets-esy/js/brk-esy-info-popup';

(function() {
  'use strict';

  start();
  // tooltips();

  const players = document.querySelectorAll('.matches-esy .tornei-matches-players .player'),
    isTeam = Boolean(document.querySelector('.matches-esy').dataset.isTeam);
  if(players.length) {

    players.forEach(item => {
      item.addEventListener('click', () => {

        info_popup(item, isTeam);
      }, false);

    });
    info_popup_listeners();
  }
})();
